export class ChargeType {
    constructor(value?: string, charge_type?: string, est_chg_type_id?: string, chg_type_descr?: string,
        expenditure_type_id?: string, expenditure_type_descr?: string) {
            this.value = value;
            this.charge_type = charge_type;
            this.est_chg_type_id = est_chg_type_id;
            this.chg_type_descr = chg_type_descr;
            this.expenditure_type_id = expenditure_type_id;
            this.expenditure_type_descr = expenditure_type_descr;
        }

    value: string;
    charge_type: string;
    est_chg_type_id: string;
    chg_type_descr: string;
    expenditure_type_id: string;
    expenditure_type_descr: string;
}